import React from 'react';

interface PatternColorSwatchProps {
  color: string;
  checked: boolean;
  onSelect: () => void;
  label: string;
  /** Radio group name. Scope it per-picker so two pickers can coexist. */
  name: string;
}

export const PatternColorSwatch: React.FC<PatternColorSwatchProps> = ({
  color,
  checked,
  onSelect,
  label,
  name,
}) => {
  return (
    <label className="cursor-pointer">
      <input
        type="radio"
        name={name}
        checked={checked}
        onChange={onSelect}
        aria-label={label}
        className="sr-only"
      />
      <span
        aria-hidden
        style={{ backgroundColor: color }}
        className={`block w-8 h-8 rounded-full transition-all ${
          checked ? 'ring-2 ring-primary ring-offset-2' : 'hover:scale-110'
        }`}
      />
    </label>
  );
};
